import React, { Component } from 'react'
import TableComp from '../../../components/_utils/table'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { RightsWrapper } from '../../../components/_utils/utils'


import { Button, Card, notification, Popconfirm, Select, Tabs, Tooltip } from 'antd'
import Request from '../../../request'

import { connect } from 'react-redux'
import styles from './styles.less'
import { getUrlPushWrapper } from '../../../routes'
import commonStyle from '../../common.less'

const TabPane = Tabs.TabPane
const Option = Select.Option

class AllAutoFollowUp extends Component {
    state = { count: 0, arr: [], list: [], loadList: false }

    constructor(props) {
        super(props)

        this.table = React.createRef()
    }

    apiRequest = params => {

        return new Promise(async resolve => {

            if (!params) {
                params = {}
            }
            if (!params.sortField) {
                params.sortField = '_id'
                params.sortOrder = 'descend'
            }

            let data = await Request.loadAllAutoFollowUp({
                ...params,
                regExFilters: []
            })
            this.setState({ count: data.total })
            resolve(data)
        })
    }

    handleDelete = (autoFollowUpID) => {
        Request.deleteAutoFollowUp({ _id: autoFollowUpID })
            .then(x => {

                if (x.success) {
                    notification.success({
                        message: x.msg,
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error',
                        description: x.msg
                    })
                }
                this.table.current.reload()
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }


    componentDidMount() {
    }

    render() {
        const { dispatch } = this.props

        const columns = [
            {
                title: 'Day',
                key: 'day',
                dataIndex: 'day',
                sorter: true,
                filterRegex: true
            },
            {
                title: 'Email Template',
                key: 'emailTemplateId.templateName',
                dataIndex: 'emailTemplateId.templateName',
                sorter: true,
                filterRegex: true
            },
            {
                title: 'SMS Template',
                key: 'smsTemplateId.templateName',
                dataIndex: 'smsTemplateId.templateName',
                sorter: true,
                filterRegex: true
            },
            {
                title: 'WhatsApp Template',
                key: 'whatsAppTemplateId.templateName',
                dataIndex: 'whatsAppTemplateId.templateName',
                sorter: true,
                filterRegex: true
            },
            {
                title: 'Last Updated By',
                key: 'lastUpdatedByName',
                dataIndex: 'lastUpdatedByName',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={commonStyle.user}>
                                {record.createdByUser.name}
                            </div>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <React.Fragment>
                        <RightsWrapper myRight={'autoFollowUp.edit'}>
                            <Tooltip title="Edit Details">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    onClick={() => {
                                        dispatch(getUrlPushWrapper('auto-follow-up.edit-auto-follow-up', { id: record._id }));
                                    }}
                                    icon="edit"
                                />
                            </Tooltip>

                        </RightsWrapper>
                        <RightsWrapper myRight={'autoFollowUp.delete'}>
                            <Tooltip title="Delete Auto Follow up">
                                <Popconfirm
                                    title="Are you sure to delete Auto Follow up?"
                                    onConfirm={() => this.handleDelete(record._id)}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        shape="circle"
                                        className={styles.btn}
                                        icon="delete" />
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                    </React.Fragment>
                )
            }
        ]
        return (
            <PageHeaderWrapper title={`Auto Follow Up : ${this.state.count} `}>
                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        apiRequest={this.apiRequest}
                        ref={this.table} />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllAutoFollowUp)
